import LogIn from './pages/LogIn.vue';
import Home from './pages/Home.vue';
import EditFile from './pages/files/EditFile.vue';
import UploadedFiles from './pages/files/UploadedFiles.vue';
import Dashboard from './pages/Dashboard.vue';
import Tasks from './pages/Tasks.vue';
import Users from './pages/Users.vue';
import Admin from './pages/Admin';

//Customer
import CustomerHome from './pages/customer/CustomerHome.vue';
import EditFileCustomer from './pages/customer/EditFileCustomer.vue';
import CustomerMigPal from '@/pages/customer/CustomerMigPal';
import CustomerDashboard from '@/pages/customer/CustomerDashboard';

import { AuthService } from './services';

export const routes = [
  {
    path: '/',
    redirect: () => (AuthService.getToken() ? '/home' : '/log-in')
  },
  {
    name: 'Login',
    path: '/log-in',
    component: LogIn
  },
  {
    path: '/home',
    name: 'Home',
    component: Home,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        name: 'Dashboard',
        path: 'dashboard',
        component: Dashboard,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'uploads',
        component: UploadedFiles,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/processing-results/:result_id',
        name: 'EditFile',
        component: EditFile,
        meta: {
          requiresAuth: true
        }
      },
      {
        name: 'Tasks',
        path: 'tasks',
        alias: '/',
        component: Tasks,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'users',
        component: Users,
        meta: {
          requiresAuth: true
        }
      }
    ]
  },
  {
    path: '/admin',
    component: Admin,
    meta: {
      requiresAuth: true,
      roles: ['admin']
    }
  },
  {
    path: '/customer',
    component: CustomerHome,
    meta: {
      customerLink: true
    },
    children: [
      {
        name: 'EditFileCustomer',
        path: ':matcherVersion?/processing-results/:result_id',
        component: EditFileCustomer,
        meta: {
          customerLink: true
        }
      },
      {
        name: 'CustomerDashboard',
        path: ':matcherVersion?/migration/:result_id/dashboard',
        component: CustomerDashboard,
        meta: {
          customerLink: true
        }
      },
      {
        name: 'CustomerMigPal',
        path: ':matcherVersion?/migration/:result_id/migration-poll',
        component: CustomerMigPal,
        meta: {
          customerLink: true
        }
      }
    ]
  }
];
